import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AttendanceList } from './AttendanceList';
import { ConversationView } from './ConversationView';
import { StartConversationModal } from './StartConversationModal';
import { useUser } from '../../app/session';
import { hasPermission } from '../../lib/api';

/**
 * Três colunas: atendimentos | conversa | painel lateral (dentro da conversa). No celular, uma tela
 * por vez: a lista e, com um atendimento aberto, a conversa (com voltar).
 */
export function WorkspacePage() {
  const { attendanceId = null } = useParams();
  const navigate = useNavigate();
  const [takeRequest, setTakeRequest] = useState<string | null>(null);
  const [starting, setStarting] = useState(false);
  const user = useUser();
  const canStart = hasPermission(user, 'message:send') && hasPermission(user, 'attendance:take');
  const select = useCallback((id: string | null) => navigate(id ? `/atendimento/${id}` : '/atendimento'), [navigate]);

  return (
    <div className="flex h-full">
      <div className={clsx('min-h-0 w-full md:w-80 md:shrink-0', attendanceId ? 'hidden md:flex' : 'flex')}>
        <AttendanceList selectedId={attendanceId} onSelect={select} onTake={(id) => setTakeRequest(id)} onStartConversation={canStart ? () => setStarting(true) : undefined} />
      </div>
      {starting && <StartConversationModal onClose={() => setStarting(false)} onOpen={(id) => select(id)} />}
      <section className={clsx('min-w-0 flex-1', !attendanceId && 'hidden md:block')}>
        {attendanceId ? (
          <ConversationView key={attendanceId} attendanceId={attendanceId} onDeselect={() => select(null)} takeRequested={takeRequest === attendanceId} onTakeHandled={() => setTakeRequest(null)} />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
            <img src="/brand/simbolo.png" alt="" aria-hidden className="size-20 opacity-20 grayscale-[30%]" />
            <div>
              <p className="font-medium" style={{ fontFamily: 'var(--font-brand)' }}>
                Nenhum atendimento aberto
              </p>
              <p className="mt-1 text-sm text-fg-soft">Escolha um atendimento na lista, assuma um da fila ou inicie uma nova conversa.</p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
